import TagManager from 'react-gtm-module';

export interface VideoEvent {
  eventName: 'video_start' | 'video_progress' | 'video_complete';
  type: 'PDP' | 'PLP' | 'Homepage' | null;
  interactionLocation:
    | 'PTT'
    | 'hero banner'
    | 'expert advice'
    | 'product gallery'
    | 'embedded'
    | 'video block'
    | null;
  videoProvider: 'Youtube' | 'Prismic' | null;
  videoUrl: string | null;
  videoTitle: string | null;
  videoDuration?: string | null;
  videoPercent?: number | null;
  path: string | null;
}

export const trackVideoEvents = ({ event }: { event: VideoEvent }) => {
  const {
    eventName,
    type,
    interactionLocation,
    path,
    videoUrl,
    videoDuration,
    videoTitle,
    videoProvider,
  } = event;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: eventName,
      page: {
        path,
        type,
      },
      interaction: {
        interaction_location: interactionLocation,
        link_url: path,
        ...(videoDuration && { video_duration: videoDuration }),
        video_title: videoTitle,
        video_provider: videoProvider,
        video_url: videoUrl,
      },
    },
  });
};
